import React from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { procedureCradData } from '../../data/procedureCardData'
import PageWrapper from '../../components/PageWrapper'
import PageContentWrapper from '../../components/PageWrapper/PageContentWrapper'
import PageNavButton from '../../components/PageNavButton'
import DirectionLink from '../../components/DirectionLink'
import ProcedureCard from '../../components/ProcedureCard'

const ProcedurePage = () => {
  const navigate = useNavigate()
  return (
    <PageWrapper>
      <Helmet>
        <title>How this works</title>
      </Helmet>
      <PageContentWrapper>
        <DirectionLink
          text="Back"
          direction="left"
          link="/first-step"
          isDepenednt={true}
          isFocused={true}
          description="Back button, to visit previous page double click here."
        />
        <ProcedureCard {...procedureCradData} />
      </PageContentWrapper>
      <PageNavButton
        onClickFunc={() => navigate('/provider')}
        content="Continue"
        ariaLabel="Continue button, to visit next page double click here"
      />
    </PageWrapper>
  )
}

export default ProcedurePage
